import { Spinner } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { LuNfc } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useIdentifyBadge } from './identify-badge.controller';

const ID = 'identify-badge';

const IdentifyBadge = () => {
    const viewProps = useIdentifyBadge();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{ show: viewProps.resolving }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.UNRECOGNIZED_CODE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            footer={{ onBack: viewProps.onBack }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-center gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <LuNfc className='text-always-black size-6' />
                <div className='text-always-black text-lg font-medium'>{CommonMessage.BUTTONS.SCAN_BADGE}</div>
            </div>

            <div className='flex flex-col items-center gap-5'>
                <div className='text-always-black text-center text-base font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.identify-badge.instructions'
                        defaultMessage='Please scan your badge'
                    />
                </div>

                <div className='bg-brand-secondary flex size-24 items-center justify-center rounded-full'>
                    {viewProps.resolving && <Spinner className='text-border-default fill-brand-primary size-25' />}
                    <ICONS.BUTTON.ARROW_DOWN className='text-always-white absolute size-10' />
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default IdentifyBadge;
